var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.3L16.3 18L15.9 17.6L15.7 17.8C15.6 17.9 15.4 17.9 15.3 17.8L15.2 17.7C15.1 17.6 15.1 17.4 15.2 17.3L15.4 17.1L15.8 16.7L14.7 15.6L15.5 14.8L16.6 15.9L17 15.5L17.2 15.3C17.3 15.2 17.5 15.2 17.6 15.3L17.7 15.4C17.8 15.5 17.8 15.7 17.7 15.8L17.5 16L18 16.3Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 19.6C19.2 20.1 18.5 20.1 18 19.6L16.3 17.9L18 16.2L19.7 17.9C20.1 18.4 20.1 19.2 19.7 19.6Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 17.2C14.2451 17.2 17.2 14.2451 17.2 10.6C17.2 6.95492 14.2451 4 10.6 4C6.95492 4 4 6.95492 4 10.6C4 14.2451 6.95492 17.2 10.6 17.2Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 15.6001C13.3614 15.6001 15.6 13.3615 15.6 10.6001C15.6 7.83867 13.3614 5.6001 10.6 5.6001C7.83857 5.6001 5.6 7.83867 5.6 10.6001C5.6 13.3615 7.83857 15.6001 10.6 15.6001Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 9.89993C13.2 9.89993 13 9.79993 12.9 9.59993C12.5 8.29993 11.1 7.59993 9.8 8.09993C9.5 8.19993 9.3 7.99993 9.2 7.79993C9.1 7.49993 9.2 7.29993 9.5 7.19993C10.4 6.89993 11.3 6.89993 12.1 7.29993C12.9 7.69993 13.6 8.39993 13.9 9.29993C14 9.59993 13.9 9.79993 13.6 9.89993C13.5 9.89993 13.5 9.89993 13.4 9.89993Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 17.4027,
    y1: 17.4088,
    x2: 14.5245,
    y2: 14.4862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20.461,
    y1: 20.2341,
    x2: 16.9185,
    y2: 17.0016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 8.1655,
    y1: 3.2325,
    x2: 12.2836,
    y2: 15.6752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90EFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3663F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 11.7452,
    y1: 6.5623,
    x2: 9.4869,
    y2: 14.7099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5B53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 11.1575,
    y1: 9.40203,
    x2: 11.9988,
    y2: 7.32083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7941D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F46227"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Search.b6a8b896.svg";
export { ForwardRef as ReactComponent };